import {Component, OnInit} from '@angular/core';
import {Emitters} from '../../helpers/core/emitters';
import {HttpRequests} from '../../helpers/core/http.requests';
import {CommonFunctions} from '../../helpers/core/common.functions';
import { DomSanitizer } from '@angular/platform-browser';
import { RequestUrls } from '../../helpers/routes/request.urls';

@Component({
    selector: 'app-odd-hours',
    templateUrl: './odd-hours.component.html'
})
export class OddHoursComponent implements OnInit {
    public title: string;
    private url: string;
    public asset_id: string;
    private callBackData;
    private callBackKey: string;
    sections: any[] = [];

    constructor(private c_f: CommonFunctions, private emitters: Emitters, private h_r: HttpRequests, private sanitizer: DomSanitizer, private r_u: RequestUrls) {
    }

    ngOnInit() {
        this.callBackData = {};
    }

    public OpenedModel(title, url, asset_id, callBackKey = 'remove') {
        this.title = title;
        this.url = url;
        this.asset_id = asset_id;
        this.callBackKey = callBackKey;
        this.c_f.setLoading(true);
        this.getAssetOddHours(asset_id);
    }

    public getAssetOddHours(asset_id) {
        this.sections = [];
        const url = this.r_u.getUrl('asset.odd-hours.get')+'/'+asset_id;
        this.h_r.HttpGet(url).subscribe(response => {
            if (response.status) {
                const data = response.data;
                data.forEach(element => {
                    const newSection = this.sanitizer.bypassSecurityTrustHtml(`<div class="form-group col-sm-6 col-md-6">
                        <label>From</label>
                        <input type="time" name="add_hours_from[]" class="form-control" value="`+element.from+`">
                    </div>
                    <div class="form-group col-sm-6 col-md-6">
                        <label>To</label>
                        <input type="time" name="add_hours_to[]" class="form-control" value="`+element.to+`">
                    </div>`);
                    this.sections.push(newSection);
                });
            }
            this.c_f.setLoading(false);
        }, err => {
            this.c_f.setLoading(false);
        });
    }

    public ConfirmedSave(event) {
        this.callBackData[this.callBackKey] = true;
        this.h_r.HttpPost(this.url, $(event.target).serialize()).subscribe(response => {
            if (response.status) {
                this.emitters.change(this.callBackData);
                this.c_f.ShowToast(response.message, 'success');
                this.c_f.CloseModel('odd-hours-model-popup');
                this.sections = [];
            } else {
                this.c_f.ShowToast(response.message, 'danger');
            }
            
            this.c_f.setLoading(false);
        }, err => {
            this.c_f.setLoading(false);
            this.c_f.ShowToast(err.message, 'danger');
        });
    }

    public addSection() {
        const newSection = this.sanitizer.bypassSecurityTrustHtml(`<div class="form-group col-sm-6 col-md-6">
                            <label>From</label>
                            <input type="time" name="add_hours_from[]" class="form-control">
                        </div>
                        <div class="form-group col-sm-6 col-md-6">
                            <label>To</label>
                            <input type="time" name="add_hours_to[]" class="form-control">
                        </div>`);
        this.sections.push(newSection);
    }

    public deleteSection(index: number) {
        this.sections.splice(index, 1); // Remove section by index
    }

    closeModal() {
        this.sections = [];
        // Close modal logic here
    }
}
